import type { IReturnLineItem } from "../types/api/order";
import type { OrderLineItem } from "../types/generated/storefront.types";

export default function useOrderLineInfo(node: OrderLineItem | IReturnLineItem) {
  const compareAtPrice = parseFloat(node.variant?.compareAtPrice?.amount || "0") * node.quantity;
  const price = parseFloat(node.variant?.price.amount || "0") * node.quantity;

  const discountedTotalPrice = parseFloat(node.discountedTotalPrice?.amount || "0");

  const isGift = node.variant?.product.tags.includes("Gift") || node.variant?.product.vendor === "GWP";

  const size = node.variant
    ? node.variant.selectedOptions.find((option) => option.name === "Size")?.value || ""
    : (/\/\s*(\d+)/.exec(("variantTitle" in node && node.variantTitle) || "") || [])[1];

  const color = node.variant?.selectedOptions.find((option) => option.name === "Color")?.value || "";

  return {
    compareAtPrice: compareAtPrice ? compareAtPrice : price,
    price: discountedTotalPrice,
    size,
    color,
    isGift,
  };
}
